import { getRoot, types, } from 'mobx-state-tree';
import * as Yup from 'yup';
import { intersection } from 'lodash-es';
import { navStore } from './NavStore';
import { fieldValidator } from './YupAdapter';
import schema, { generateType, } from './Schema';
import { Item } from './ItemModel';
import { slugify } from './itemCommon';
const DocumentModel = generateType(schema.getModel('document'))
    .views((self) => ({
    isAsset() {
        return false;
    },
    isCourse() {
        return false;
    },
    isDocument() {
        return true;
    },
    isMeeting() {
        return false;
    },
    isMicrocast() {
        return false;
    },
    isProgram() {
        return false;
    },
    itemImage() {
        if (self.image) {
            return self.image;
        }
        return self.asset;
    },
}))
    .actions(() => ({}))
    .views((self) => ({
    checkAccess() {
        // @TODO uses exact same logic as amplify/function/trackProgress.checkAccess
        // consolidate to one place.
        const rootModel = getRoot(self); // as IRootModel;
        const access = rootModel.currentAccess;
        if (!access) {
            return false;
        }
        const { excludeFromAllCourses, accessGroups: courseAccessGroups } = self;
        const customerAccessGroups = access.groups || [];
        if (!excludeFromAllCourses && customerAccessGroups.includes('ALL_COURSES')) {
            // console.log('Access granted via ALL_COURSES group');
            return true;
        }
        const commonGroups = intersection(courseAccessGroups, customerAccessGroups);
        if (commonGroups.length > 0) {
            console.log('Access granted via accessGroups: ', commonGroups);
            return true;
        }
        if (access.purchasedPrograms.indexOf(`,${self.id},`) >= 0) {
            console.log('Access granted via purchasedPrograms');
            return true;
        }
        return false;
    },
}));
export const Document = types
    .compose(DocumentModel, Item)
    .actions((self) => ({
    async preUpdate() {
        self.setInstuctorNames();
        if (!self.manualSlug) {
            self.slug = slugify(self.name);
        }
        const slugValidator = fieldValidator('slug', {
            type: 'string',
            validation: 'slug',
        }, false);
        try {
            slugValidator?.validateSync(self.slug, { abortEarly: false });
        }
        catch (error) {
            if (error instanceof Yup.ValidationError) {
                console.error('Validation error:', error.errors);
                navStore.errorDialog.showError('Validation Error', `slug: ${error.message}`);
            }
            throw error;
        }
    },
}))
    .named('Document');
export const DocumentProgress = generateType(schema.getModel('documentProgress') /* , overrideMap */)
    .views((self) => ({
    getItem() {
        return self.document;
    },
}));
export const startDocumentGQL = (isPortalApi) => (`
  mutation StartDocument(
    $documentKey: String!
    $portalID: String!
    ${!isPortalApi ? '$organizationID: String!' : ''}
  ) {
    startDocument(
      documentKey: $documentKey
      portalID: $portalID
      ${!isPortalApi ? 'organizationID: $organizationID' : ''}      
    ) {
      statusCode
      documentProgress {
        ${schema.getGqlPropertyList('documentProgress', isPortalApi).join(' ')}
      }
      programProgresses {
        ${schema.getGqlPropertyList('programProgress', isPortalApi).join(' ')}
      }
      message
    }
  }
`);
export const trackDocumentProgressGQL = (isPortalApi) => (`
mutation TrackDocumentProgress(
  $documentKey: String
  ${!isPortalApi ? '$organizationID: String!' : ''}
  $progress: String
) {
  trackDocumentProgress(
    documentKey: $documentKey
    ${!isPortalApi ? 'organizationID: $organizationID' : ''}      
    progress: $progress
  ) {
    statusCode
    documentProgress {
      ${schema.getGqlPropertyList('documentProgress', isPortalApi).join(' ')}
    }
    programProgresses {
      ${schema.getGqlPropertyList('programProgress', isPortalApi).join(' ')}
    }
  }
}`);
//# sourceMappingURL=DocumentModel.js.map